import { IPage } from "@/interfaces/IPage";
import { IViewConfiguration } from "@/interfaces/IViewConfiguration";
import { Component } from "vue";

export class Page implements IPage {
  id: number;
  name: string;
  Views: Array<IViewConfiguration>;

  constructor(id: number, view: Array<IViewConfiguration>, name: string) {
    this.Views = view;
    this.name = name;
    this.id = id;
  }
}

export default class ViewConfiguration implements IViewConfiguration {
  Identifier: string;

  constructor(identifier: string) {
    this.Identifier = identifier;
  }
}
